<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('calendarAccount_title') }}</h6>
    <div class="flex items-center gap-6">
        <app-svg name="importantMark" [color]="ss.theme().color14" width="20px" height="20px"
            *ngIf="cc.user.uid && ss.isInGracePeriod()" role="button" (click)="ds.featureExpiringSoon()"></app-svg>
        <app-svg name="more" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button" *ngIf="data.mode === 'edit'"
            [color]="ss.theme().color12"></app-svg>


        <mat-menu #infoMenu="matMenu" yPosition="above" xPosition="before" class="me-menu info-menu">


            <button mat-menu-item (click)="openFeatureGuide()">
                <span class="text-14-400 color-8 flex items-center gap-3">
                    <app-svg name="commonMenuInfo" class="flex items-center justify-center"
                        [color]="ss.theme().color35"></app-svg>
                    {{ ss.t('common_info')
                    }}
                </span>
            </button>

            <button mat-menu-item (click)="save(true)">
                <span class="text-14-400 color-8 flex items-center gap-3">
                    <app-svg name="resync" class="flex items-center justify-center" width="14" height="14"
                        [color]="ss.theme().color35"></app-svg>
                    {{ ss.t('calendarAccount_resyncCalendar')
                    }}
                </span>
            </button>

            <button mat-menu-item (click)="deleteCalendar()">
                <span class="text-14-400 color-11 flex items-center gap-3">
                    <app-svg name="commonMenutrash" class="flex items-center justify-center"
                        [color]="ss.theme().color11"></app-svg>
                    {{ ss.t('deleteAccount_title')
                    }}
                </span>
            </button>

        </mat-menu>

        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>

<!-- Account Error Banner -->
<div class="calendar-error-banner" *ngIf="data.mode === 'edit' && data.value.status === 'accountError'">
    <div class="flex items-center ri-px-4 ri-pt-2">
        <app-svg name="importantAlert" [color]="ss.theme().color7" width="12px" height="12px"></app-svg>
        <span class="text-12-400 color-7 ri-ms-2">{{ ss.t('calendar_syncFailedReAuth') }}</span>
    </div>
    <div class="flex justify-end ri-px-4">
        <button class="btn btn-text text-12-400 color-14" (click)="reAuthenticate()">{{ ss.t('calendar_authenticateNow')
            }}</button>
    </div>
</div>

<div class="calendar-account-form ri-p-4">
    <div>
        <!-- Account Info -->
        <div class="flex items-start ri-pb-4">
            <app-svg name="user" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ calendarAccountInfo.name }}</p>
                <p class="text-12-400 color-7 mb-0">{{ calendarAccountInfo.email }}</p>
            </div>
        </div>

        <!-- Mevolve to Calendar Section -->
        <div class="flex items-start ri-pb-4">
            <app-svg name="mevolveToCalendar" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ ss.t('calendarAccount_brandToCalendar', { brandName: BRAND_CONFIG.name }) }}</p>
                <p class="text-12-400 color-7 mb-0 ri-pb-2">{{ ss.t('calendarAccount_brandContent', { brandName: BRAND_CONFIG.name }) }}</p>

                <!-- Todos Sync — single toggle -->
                <div class="flex justify-between items-center ri-pb-2">
                    <div class="flex items-center flex-1 min-w-0 ri-me-2">
                        <p class="text-16-400 color-8 mb-0">{{ ss.t('common_todos') }}</p>
                        <app-svg *ngIf="isMevolveSyncEnabled('todos')"
                            [name]="hasMevolveReminders('todos') ? 'notification' : 'noNotification'"
                            [color]="hasMevolveReminders('todos') ? ss.theme().color35 : ss.theme().color7"
                            class="ri-ms-2 flex-shrink-0" (click)="toggleMevolveReminder('todos')" role="button">
                        </app-svg>
                    </div>
                    <app-input-checkbox [id]="'sync-todos'" [checked]="isMevolveSyncEnabled('todos')"
                        (change)="toggleMevolveSync('todos')" [readonly]="isSaving()">
                    </app-input-checkbox>
                </div>

                <!-- Habits — per-setup toggles -->
                <ng-container *ngIf="scheduledHabitSetups().length > 0">
                    <p class="text-12-500 color-7 mb-0 ri-pt-3 ri-pb-1">{{ ss.t('common_habits') }}</p>
                    <ng-container *ngFor="let setup of scheduledHabitSetups()">
                        <div class="flex justify-between items-center ri-pb-2 ri-ps-3">
                            <div class="flex items-center flex-1 min-w-0 ri-me-2">
                                <p class="text-14-400 color-8 mb-0">{{ setup.title }}</p>
                                <app-svg *ngIf="isMevolveSyncEnabled('habits', setup.id)"
                                    [name]="hasMevolveReminders('habits', setup.id) ? 'notification' : 'noNotification'"
                                    [color]="hasMevolveReminders('habits', setup.id) ? ss.theme().color35 : ss.theme().color7"
                                    class="ri-ms-2 flex-shrink-0" (click)="toggleSetupReminder('habits', setup.id)" role="button">
                                </app-svg>
                            </div>
                            <app-input-checkbox [id]="'sync-habit-' + setup.id" [checked]="isMevolveSyncEnabled('habits', setup.id)"
                                (change)="toggleSetupSync('habits', setup.id)" [readonly]="isSaving()">
                            </app-input-checkbox>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Journals — per-setup toggles -->
                <ng-container *ngIf="scheduledJournalSetups().length > 0">
                    <p class="text-12-500 color-7 mb-0 ri-pt-3 ri-pb-1">{{ ss.t('common_journals') }}</p>
                    <ng-container *ngFor="let setup of scheduledJournalSetups()">
                        <div class="flex justify-between items-center ri-pb-2 ri-ps-3">
                            <div class="flex items-center flex-1 min-w-0 ri-me-2">
                                <p class="text-14-400 color-8 mb-0">{{ setup.title }}</p>
                                <app-svg *ngIf="isMevolveSyncEnabled('journals', setup.id)"
                                    [name]="hasMevolveReminders('journals', setup.id) ? 'notification' : 'noNotification'"
                                    [color]="hasMevolveReminders('journals', setup.id) ? ss.theme().color35 : ss.theme().color7"
                                    class="ri-ms-2 flex-shrink-0" (click)="toggleSetupReminder('journals', setup.id)" role="button">
                                </app-svg>
                            </div>
                            <app-input-checkbox [id]="'sync-journal-' + setup.id" [checked]="isMevolveSyncEnabled('journals', setup.id)"
                                (change)="toggleSetupSync('journals', setup.id)" [readonly]="isSaving()">
                            </app-input-checkbox>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Focus — per-setup toggles -->
                <ng-container *ngIf="scheduledFocusSetups().length > 0">
                    <p class="text-12-500 color-7 mb-0 ri-pt-3 ri-pb-1">{{ ss.t('common_focusTracker') }}</p>
                    <ng-container *ngFor="let setup of scheduledFocusSetups()">
                        <div class="flex justify-between items-center ri-pb-2 ri-ps-3">
                            <div class="flex items-center flex-1 min-w-0 ri-me-2">
                                <p class="text-14-400 color-8 mb-0">{{ setup.title }}</p>
                                <app-svg *ngIf="isMevolveSyncEnabled('focus', setup.id)"
                                    [name]="hasMevolveReminders('focus', setup.id) ? 'notification' : 'noNotification'"
                                    [color]="hasMevolveReminders('focus', setup.id) ? ss.theme().color35 : ss.theme().color7"
                                    class="ri-ms-2 flex-shrink-0" (click)="toggleSetupReminder('focus', setup.id)" role="button">
                                </app-svg>
                            </div>
                            <app-input-checkbox [id]="'sync-focus-' + setup.id" [checked]="isMevolveSyncEnabled('focus', setup.id)"
                                (change)="toggleSetupSync('focus', setup.id)" [readonly]="isSaving()">
                            </app-input-checkbox>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Money Tracker — per-setup with schedules -->
                <ng-container *ngIf="scheduledMoneyTrackerSetups().length > 0">
                    <p class="text-12-500 color-7 mb-0 ri-pt-3 ri-pb-1">{{ ss.t('common_moneyTracker') }}</p>
                    <ng-container *ngFor="let item of scheduledMoneyTrackerSetups()">
                        <!-- Setup name as sub-header -->
                        <p class="text-12-400 color-7 mb-0 ri-pt-2 ri-pb-1 ri-ps-3">{{ item.setup.title }}</p>
                        <!-- Individual schedule toggles -->
                        <ng-container *ngFor="let schedule of item.schedules">
                            <div class="flex justify-between items-center ri-pb-2 ri-ps-6">
                                <div class="flex items-center flex-1 min-w-0 ri-me-2">
                                    <p class="text-14-400 color-8 mb-0">{{ schedule.title }}</p>
                                    <app-svg *ngIf="isMevolveSyncEnabled('moneyTracker', item.setup.id, schedule.id)"
                                        [name]="hasMevolveReminders('moneyTracker', item.setup.id, schedule.id) ? 'notification' : 'noNotification'"
                                        [color]="hasMevolveReminders('moneyTracker', item.setup.id, schedule.id) ? ss.theme().color35 : ss.theme().color7"
                                        class="ri-ms-2 flex-shrink-0" (click)="toggleSetupReminder('moneyTracker', item.setup.id, schedule.id)" role="button">
                                    </app-svg>
                                </div>
                                <app-input-checkbox [id]="'sync-mt-' + item.setup.id + '-' + schedule.id"
                                    [checked]="isMevolveSyncEnabled('moneyTracker', item.setup.id, schedule.id)"
                                    (change)="toggleSetupSync('moneyTracker', item.setup.id, schedule.id)" [readonly]="isSaving()">
                                </app-input-checkbox>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <!-- Calendar to Mevolve Section -->
        <div class="flex items-start ri-pb-4">
            <app-svg name="calendarToMevolve" [color]="ss.theme().color35"></app-svg>
            <div class="ri-ps-3 w-full">
                <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ ss.t('calendarAccount_calendarToBrand', { brandName: BRAND_CONFIG.name }) }}</p>
                <p class="text-12-400 color-7 mb-0 ri-pb-2">{{ ss.t('calendarAccount_calendarContent', { brandName: BRAND_CONFIG.name }) }}</p>

                <!-- Calendar Groups -->
                <ng-container *ngFor="let calGroup of currentState().calendarGroups">
                    <div class="flex justify-between items-center ri-pb-2">
                        <div class="flex items-center flex-1 min-w-0 ri-me-2">
                            <p class="text-16-400 color-8 mb-0">
                                {{ getCalendarGroupDisplayName(calGroup.title) }}<app-svg *ngIf="isCalendarGroupEnabled(calGroup.id)"
                                    [name]="hasCalendarGroupReminders(calGroup.id) ? 'notification' : 'noNotification'"
                                    [color]="hasCalendarGroupReminders(calGroup.id) ? ss.theme().color35 : ss.theme().color7"
                                    class="ri-ms-2" style="vertical-align: middle;" (click)="toggleCalendarGroupReminder(calGroup.id)"
                                    role="button">
                                </app-svg>
                            </p>

                        </div>
                        <app-input-checkbox [id]="'cal-group-' + calGroup.id"
                            [checked]="isCalendarGroupEnabled(calGroup.id)" (change)="toggleCalendarGroup(calGroup.id)"
                            [readonly]="isSaving()">
                        </app-input-checkbox>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="bottom-section ri-py-3 ri-px-4 ri-bt-2 flex items-center">

    <span class="flex items-center" *ngIf="isSaving() || isSyncing()">
        <app-svg name="resync" [color]="ss.theme().color35" class="ri-me-2" height="18px" width="18px"></app-svg>
        <span class="text-14-400 color-8">{{ ss.t('common_syncingEvents') }}</span>
    </span>

    <button type="submit" class="btn-text text-16-500 color-35 ms-auto"
        (click)="(hasChanges() || data.mode === 'new') ? save() : closeDialog()" [disabled]="isSaving() || isSyncing()">
        {{ (hasChanges() || data.mode === 'new') ? ss.t('common_save') : ss.t('common_close') }}
    </button>
</div>